// removed by extract-text-webpack-plugin
module.exports = {"Card":"_1TlxCiK9X6tYYb69zDGX9V","Title":"_1rou2BcmnViSTObivnppyK","Filters":"Fg07abdKB0kudZmS1WLN8","Row":"_3QC0RDjDqpp2tbsxlH3U6Q","Col":"rx7HF-JfF_pa0-rF3oiyQ","Checkbox":"_39zV5VjAZ-xfNTxXwNW1Qa","Footer":"Uwg-9xan2bHpaaJRp_3aL","LinkBtn":"_1JzWwAxCuSeWrYyOJZWNmT"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/RegistryControls/styles.module.css
// module id = 571
// module chunks = 0